var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between items-center mb-4"},[_c('p',{staticClass:"text-sm text-blue-500",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"text-sm text-gray-900"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }